var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlackWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.30135 10.9022L6.81003 3.90419C7.30197 2.92301 8.70248 2.92327 9.19407 3.90463L12.6995 10.9026C13.1436 11.7892 12.499 12.8331 11.5074 12.8331H4.49326C3.50144 12.8331 2.85682 11.7888 3.30135 10.9022Z",
    stroke: "#141414",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 6.6665V7.99984",
    stroke: "#141414",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33317 10.6668C8.33317 10.8509 8.18393 11.0002 7.99984 11.0002C7.81574 11.0002 7.6665 10.8509 7.6665 10.6668C7.6665 10.4827 7.81574 10.3335 7.99984 10.3335C8.18393 10.3335 8.33317 10.4827 8.33317 10.6668Z",
    stroke: "#141414"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackWarning);
export default __webpack_public_path__ + "static/media/blackWarning.4f8f3da781f6564463a679feb346f889.svg";
export { ForwardRef as ReactComponent };